import { render, staticRenderFns } from "./VoicemailTool.vue?vue&type=template&id=035c4e90&scoped=true"
import script from "./VoicemailTool.vue?vue&type=script&lang=js"
export * from "./VoicemailTool.vue?vue&type=script&lang=js"
import style0 from "./VoicemailTool.vue?vue&type=style&index=0&id=035c4e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035c4e90",
  null
  
)

export default component.exports